export const newAddedStreetId = 0;
